export default {
  "type": "Topology",
  "transform": {
    "scale": [
      0.00010652073592474735,
      0.00006481816123920856
    ],
    "translate": [
      2.558148000000074,
      49.49944999999997
    ]
  },
  "arcs": [
    [
      [
        22577,
        30160
      ],
      [
        43,
        -90
      ],
      [
        -67,
        -20
      ],
      [
        -69,
        -42
      ],
      [
        -18,
        -70
      ],
      [
        -2,
        -60
      ],
      [
        10,
        -75
      ],
      [
        -64,
        -37
      ],
      [
        -75,
        12
      ],
      [
        -78,
        41
      ],
      [
        -18,
        87
      ],
      [
        4,
        76
      ],
      [
        4,
        75
      ],
      [
        28,
        38
      ],
      [
        61,
        20
      ],
      [
        59,
        -16
      ],
      [
        182,
        61
      ]
    ],
    [
      [
        25186,
        27187
      ],
      [
        45,
        -22
      ],
      [
        -172,
        -147
      ],
      [
        -103,
        -590
      ],
      [
        382,
        -370
      ],
      [
        31,
        -624
      ],
      [
        -236,
        -216
      ],
      [
        -303,
        92
      ],
      [
        -213,
        -321
      ],
      [
        -471,
        -25
      ],
      [
        -379,
        -499
      ],
      [
        -751,
        -156
      ],
      [
        -1,
        -211
      ],
      [
        -270,
        -393
      ]
    ],
    [
      [
        22745,
        23705
      ],
      [
        -131,
        162
      ],
      [
        -176,
        -12
      ],
      [
        -362,
        -151
      ],
      [
        -252,
        -232
      ],
      [
        -115,
        59
      ],
      [
        -488,
        -210
      ],
      [
        -121,
        85
      ],
      [
        -160,
        362
      ],
      [
        -307,
        -242
      ],
      [
        -208,
        46
      ],
      [
        -365,
        -425
      ],
      [
        106,
        244
      ],
      [
        -252,
        142
      ],
      [
        -685,
        -190
      ],
      [
        -122,
        -315
      ],
      [
        -144,
        3
      ],
      [
        -300,
        183
      ],
      [
        -170,
        -165
      ],
      [
        -317,
        251
      ],
      [
        -170,
        -267
      ],
      [
        -210,
        222
      ],
      [
        -570,
        -144
      ],
      [
        -45,
        229
      ],
      [
        -176,
        56
      ],
      [
        90,
        234
      ],
      [
        -293,
        -203
      ],
      [
        -61,
        30
      ],
      [
        64,
        110
      ],
      [
        -463,
        216
      ],
      [
        -228,
        41
      ],
      [
        -322,
        -87
      ]
    ],
    [
      [
        15792,
        23737
      ],
      [
        -79,
        96
      ],
      [
        -184,
        -157
      ],
      [
        -212,
        97
      ],
      [
        82,
        249
      ],
      [
        -119,
        101
      ],
      [
        -100,
        607
      ],
      [
        351,
        318
      ],
      [
        313,
        -110
      ],
      [
        607,
        177
      ],
      [
        145,
        169
      ],
      [
        44,
        594
      ],
      [
        -50,
        195
      ],
      [
        -227,
        339
      ],
      [
        81,
        54
      ],
      [
        -199,
        662
      ],
      [
        60,
        155
      ],
      [
        245,
        269
      ],
      [
        -417,
        259
      ],
      [
        -69,
        629
      ],
      [
        -486,
        449
      ]
    ],
    [
      [
        15578,
        28889
      ],
      [
        34,
        64
      ],
      [
        124,
        8
      ],
      [
        106,
        -2
      ],
      [
        47,
        -1
      ],
      [
        228,
        7
      ],
      [
        20,
        1
      ],
      [
        10,
        26
      ],
      [
        9,
        23
      ],
      [
        15,
        3
      ],
      [
        532,
        14
      ],
      [
        85,
        -317
      ],
      [
        188,
        8
      ],
      [
        126,
        -11
      ],
      [
        158,
        -7
      ],
      [
        111,
        63
      ],
      [
        123,
        50
      ],
      [
        10,
        7
      ],
      [
        45,
        130
      ],
      [
        -19,
        103
      ],
      [
        -8,
        48
      ],
      [
        -206,
        241
      ],
      [
        -26,
        30
      ],
      [
        -3,
        9
      ],
      [
        -37,
        107
      ],
      [
        -32,
        94
      ],
      [
        8,
        126
      ],
      [
        1,
        14
      ],
      [
        18,
        293
      ],
      [
        0,
        11
      ],
      [
        3,
        37
      ],
      [
        25,
        32
      ],
      [
        66,
        84
      ],
      [
        29,
        36
      ],
      [
        7,
        9
      ],
      [
        58,
        26
      ],
      [
        104,
        59
      ],
      [
        156,
        104
      ],
      [
        115,
        41
      ],
      [
        110,
        43
      ],
      [
        111,
        69
      ],
      [
        94,
        -14
      ],
      [
        8,
        -1
      ],
      [
        36,
        2
      ],
      [
        111,
        13
      ],
      [
        129,
        29
      ],
      [
        177,
        29
      ],
      [
        20,
        -26
      ],
      [
        43,
        -56
      ],
      [
        56,
        -90
      ],
      [
        15,
        -23
      ],
      [
        -24,
        -62
      ],
      [
        -100,
        -160
      ],
      [
        -15,
        -27
      ],
      [
        -35,
        -61
      ],
      [
        -29,
        -77
      ],
      [
        1,
        -24
      ],
      [
        63,
        -337
      ],
      [
        16,
        4
      ],
      [
        247,
        58
      ],
      [
        241,
        58
      ],
      [
        55,
        -25
      ],
      [
        164,
        -33
      ],
      [
        131,
        -10
      ],
      [
        41,
        -4
      ],
      [
        76,
        -43
      ],
      [
        64,
        -5
      ],
      [
        28,
        8
      ],
      [
        35,
        10
      ],
      [
        6,
        10
      ],
      [
        61,
        -11
      ],
      [
        7,
        19
      ],
      [
        8,
        20
      ],
      [
        23,
        -4
      ],
      [
        21,
        -4
      ],
      [
        108,
        -21
      ],
      [
        -1,
        82
      ],
      [
        -15,
        112
      ],
      [
        13,
        100
      ],
      [
        132,
        92
      ],
      [
        137,
        84
      ],
      [
        44,
        154
      ],
      [
        68,
        25
      ],
      [
        40,
        42
      ],
      [
        44,
        66
      ],
      [
        12,
        32
      ],
      [
        29,
        77
      ],
      [
        39,
        76
      ],
      [
        1,
        2
      ],
      [
        19,
        23
      ],
      [
        124,
        146
      ],
      [
        11,
        4
      ],
      [
        117,
        45
      ],
      [
        127,
        48
      ],
      [
        70,
        -30
      ],
      [
        90,
        -39
      ],
      [
        80,
        -34
      ],
      [
        166,
        -140
      ],
      [
        102,
        -86
      ],
      [
        33,
        -28
      ],
      [
        16,
        -13
      ],
      [
        11,
        -318
      ],
      [
        1,
        -17
      ],
      [
        -32,
        -91
      ],
      [
        -44,
        -125
      ],
      [
        -24,
        -69
      ],
      [
        43,
        -218
      ],
      [
        10,
        -48
      ],
      [
        -56,
        23
      ],
      [
        -26,
        4
      ],
      [
        -66,
        9
      ],
      [
        -79,
        12
      ],
      [
        -90,
        34
      ],
      [
        -43,
        21
      ],
      [
        -35,
        16
      ],
      [
        -64,
        28
      ],
      [
        -120,
        -47
      ],
      [
        26,
        -64
      ],
      [
        9,
        -28
      ],
      [
        10,
        -30
      ],
      [
        43,
        -85
      ],
      [
        81,
        -65
      ],
      [
        26,
        -12
      ],
      [
        33,
        -16
      ],
      [
        146,
        -1
      ],
      [
        186,
        -1
      ],
      [
        272,
        54
      ],
      [
        70,
        15
      ],
      [
        55,
        10
      ],
      [
        90,
        18
      ],
      [
        23,
        -15
      ],
      [
        253,
        -173
      ],
      [
        25,
        -17
      ],
      [
        83,
        -57
      ],
      [
        6,
        7
      ],
      [
        10,
        -14
      ],
      [
        1,
        0
      ],
      [
        63,
        -8
      ],
      [
        18,
        -2
      ],
      [
        84,
        68
      ],
      [
        70,
        88
      ],
      [
        79,
        93
      ],
      [
        94,
        98
      ],
      [
        119,
        107
      ],
      [
        101,
        100
      ],
      [
        114,
        88
      ],
      [
        41,
        88
      ],
      [
        21,
        87
      ],
      [
        36,
        72
      ],
      [
        -2,
        57
      ],
      [
        0,
        10
      ],
      [
        -17,
        73
      ],
      [
        27,
        101
      ],
      [
        25,
        45
      ],
      [
        18,
        31
      ],
      [
        75,
        88
      ],
      [
        64,
        62
      ],
      [
        130,
        -214
      ],
      [
        21,
        -6
      ],
      [
        271,
        -65
      ],
      [
        119,
        -278
      ],
      [
        24,
        -296
      ],
      [
        1,
        -19
      ],
      [
        -196,
        -367
      ],
      [
        -8,
        -148
      ],
      [
        5,
        -6
      ],
      [
        54,
        -66
      ],
      [
        355,
        -439
      ],
      [
        24,
        -29
      ],
      [
        134,
        -688
      ],
      [
        62,
        8
      ],
      [
        8,
        1
      ],
      [
        313,
        38
      ],
      [
        36,
        32
      ],
      [
        159,
        12
      ],
      [
        53,
        16
      ],
      [
        40,
        12
      ],
      [
        17,
        4
      ],
      [
        105,
        -78
      ],
      [
        111,
        -82
      ],
      [
        15,
        -16
      ],
      [
        105,
        -105
      ],
      [
        -77,
        -268
      ],
      [
        -86,
        -228
      ],
      [
        17,
        -92
      ],
      [
        97,
        -82
      ],
      [
        3,
        -2
      ],
      [
        1,
        -1
      ]
    ],
    [
      [
        17483,
        21705
      ],
      [
        148,
        -263
      ],
      [
        -5,
        -148
      ],
      [
        -147,
        -157
      ],
      [
        378,
        -251
      ],
      [
        148,
        -489
      ],
      [
        -199,
        -27
      ],
      [
        -79,
        -136
      ],
      [
        313,
        -240
      ],
      [
        -764,
        -426
      ],
      [
        -199,
        -49
      ],
      [
        -206,
        39
      ],
      [
        -259,
        182
      ],
      [
        -248,
        547
      ],
      [
        -171,
        -92
      ],
      [
        -352,
        204
      ],
      [
        112,
        236
      ],
      [
        238,
        41
      ],
      [
        59,
        259
      ],
      [
        -95,
        176
      ],
      [
        177,
        365
      ],
      [
        345,
        180
      ],
      [
        401,
        -70
      ],
      [
        244,
        250
      ],
      [
        161,
        -131
      ]
    ],
    [
      [
        15792,
        23737
      ],
      [
        -218,
        -739
      ],
      [
        -216,
        -102
      ],
      [
        -304,
        109
      ],
      [
        -143,
        -308
      ],
      [
        133,
        -432
      ],
      [
        -4,
        -196
      ],
      [
        -217,
        -159
      ],
      [
        -430,
        188
      ],
      [
        83,
        -298
      ],
      [
        -249,
        -192
      ],
      [
        136,
        -125
      ],
      [
        -9,
        -163
      ],
      [
        -439,
        -662
      ],
      [
        240,
        -47
      ],
      [
        84,
        -226
      ],
      [
        -136,
        -434
      ],
      [
        -282,
        -249
      ],
      [
        -160,
        -67
      ],
      [
        -132,
        128
      ],
      [
        -160,
        -210
      ],
      [
        -243,
        200
      ],
      [
        -116,
        -68
      ],
      [
        -120,
        -275
      ],
      [
        196,
        -279
      ],
      [
        -13,
        -83
      ],
      [
        -304,
        -81
      ],
      [
        -219,
        82
      ]
    ],
    [
      [
        12550,
        19049
      ],
      [
        -99,
        266
      ],
      [
        -530,
        -121
      ],
      [
        -125,
        129
      ],
      [
        -376,
        -46
      ],
      [
        -158,
        484
      ],
      [
        -406,
        -180
      ],
      [
        -99,
        208
      ],
      [
        -269,
        -157
      ],
      [
        -382,
        -773
      ],
      [
        -263,
        191
      ],
      [
        -620,
        11
      ],
      [
        -62,
        486
      ],
      [
        -374,
        -117
      ],
      [
        -330,
        129
      ]
    ],
    [
      [
        8457,
        19559
      ],
      [
        457,
        380
      ],
      [
        139,
        205
      ],
      [
        -216,
        310
      ],
      [
        121,
        159
      ],
      [
        -581,
        520
      ],
      [
        221,
        237
      ],
      [
        -75,
        289
      ],
      [
        -146,
        63
      ],
      [
        -217,
        -139
      ],
      [
        -77,
        213
      ],
      [
        126,
        129
      ],
      [
        -74,
        177
      ],
      [
        222,
        -34
      ],
      [
        66,
        70
      ],
      [
        -143,
        147
      ],
      [
        189,
        -3
      ],
      [
        -452,
        235
      ],
      [
        290,
        136
      ],
      [
        -161,
        226
      ],
      [
        246,
        380
      ],
      [
        -281,
        500
      ],
      [
        203,
        152
      ],
      [
        -1062,
        784
      ],
      [
        411,
        278
      ],
      [
        337,
        663
      ],
      [
        -219,
        403
      ],
      [
        -255,
        86
      ],
      [
        227,
        167
      ],
      [
        -160,
        400
      ],
      [
        311,
        202
      ],
      [
        -188,
        507
      ],
      [
        -31,
        252
      ]
    ],
    [
      [
        7685,
        27653
      ],
      [
        71,
        -52
      ],
      [
        -13,
        -80
      ],
      [
        -4,
        -93
      ],
      [
        110,
        -41
      ],
      [
        43,
        -66
      ],
      [
        69,
        -99
      ],
      [
        75,
        -6
      ],
      [
        88,
        -41
      ],
      [
        37,
        -75
      ],
      [
        25,
        -89
      ],
      [
        101,
        -66
      ],
      [
        143,
        -18
      ],
      [
        152,
        12
      ],
      [
        313,
        17
      ],
      [
        182,
        33
      ],
      [
        -84,
        514
      ],
      [
        4,
        0
      ],
      [
        -3,
        14
      ],
      [
        -16,
        69
      ],
      [
        -5,
        22
      ],
      [
        118,
        43
      ],
      [
        114,
        -20
      ],
      [
        45,
        43
      ],
      [
        84,
        -19
      ],
      [
        33,
        90
      ],
      [
        48,
        8
      ],
      [
        118,
        -89
      ],
      [
        52,
        -12
      ],
      [
        24,
        80
      ],
      [
        12,
        60
      ],
      [
        4,
        18
      ],
      [
        79,
        86
      ],
      [
        128,
        -65
      ],
      [
        140,
        -82
      ],
      [
        98,
        -43
      ],
      [
        116,
        -57
      ],
      [
        115,
        10
      ],
      [
        108,
        9
      ],
      [
        156,
        -85
      ],
      [
        97,
        -60
      ],
      [
        33,
        -26
      ],
      [
        51,
        -39
      ],
      [
        102,
        -73
      ],
      [
        73,
        -19
      ],
      [
        42,
        -10
      ],
      [
        20,
        5
      ],
      [
        65,
        18
      ],
      [
        80,
        -10
      ],
      [
        112,
        7
      ],
      [
        61,
        -57
      ],
      [
        26,
        -80
      ],
      [
        58,
        -25
      ],
      [
        22,
        5
      ],
      [
        19,
        5
      ],
      [
        26,
        6
      ],
      [
        200,
        -105
      ],
      [
        -78,
        -176
      ],
      [
        -14,
        -80
      ],
      [
        -2,
        -88
      ],
      [
        0,
        -9
      ],
      [
        -6,
        -301
      ],
      [
        182,
        -159
      ],
      [
        426,
        88
      ],
      [
        215,
        45
      ],
      [
        26,
        -69
      ],
      [
        6,
        -15
      ],
      [
        -5,
        -5
      ],
      [
        -1,
        -1
      ],
      [
        13,
        -12
      ],
      [
        35,
        -90
      ],
      [
        168,
        -34
      ],
      [
        207,
        179
      ],
      [
        165,
        39
      ],
      [
        41,
        10
      ],
      [
        154,
        36
      ],
      [
        101,
        114
      ],
      [
        34,
        37
      ],
      [
        7,
        8
      ],
      [
        52,
        58
      ],
      [
        93,
        105
      ],
      [
        62,
        69
      ],
      [
        51,
        9
      ],
      [
        80,
        16
      ],
      [
        92,
        17
      ],
      [
        121,
        24
      ],
      [
        22,
        4
      ],
      [
        48,
        9
      ],
      [
        124,
        24
      ],
      [
        445,
        307
      ],
      [
        651,
        509
      ],
      [
        64,
        50
      ],
      [
        27,
        21
      ],
      [
        63,
        95
      ],
      [
        259,
        397
      ],
      [
        17,
        16
      ],
      [
        114,
        126
      ],
      [
        30,
        42
      ],
      [
        21,
        29
      ],
      [
        -14,
        26
      ],
      [
        -47,
        70
      ],
      [
        -49,
        20
      ],
      [
        -18,
        7
      ],
      [
        -4,
        29
      ],
      [
        -8,
        72
      ],
      [
        -52,
        67
      ],
      [
        -6,
        2
      ],
      [
        14,
        27
      ]
    ],
    [
      [
        23873,
        18673
      ],
      [
        -248,
        -44
      ],
      [
        -143,
        71
      ],
      [
        -154,
        210
      ],
      [
        5,
        273
      ],
      [
        -230,
        140
      ]
    ],
    [
      [
        23103,
        19323
      ],
      [
        -354,
        294
      ],
      [
        -461,
        -381
      ],
      [
        -142,
        -22
      ],
      [
        -119,
        104
      ],
      [
        34,
        277
      ],
      [
        -709,
        -76
      ],
      [
        40,
        168
      ],
      [
        -225,
        22
      ],
      [
        -200,
        348
      ],
      [
        -394,
        142
      ],
      [
        -251,
        -95
      ],
      [
        -81,
        -196
      ],
      [
        -37,
        115
      ],
      [
        -165,
        -97
      ],
      [
        -491,
        132
      ],
      [
        -38,
        -394
      ],
      [
        171,
        -241
      ],
      [
        -182,
        -221
      ],
      [
        -313,
        -17
      ],
      [
        -50,
        335
      ],
      [
        -221,
        -252
      ],
      [
        -411,
        -101
      ],
      [
        -21,
        -191
      ],
      [
        -299,
        180
      ],
      [
        -46,
        77
      ],
      [
        40,
        178
      ],
      [
        -136,
        20
      ],
      [
        -206,
        -67
      ],
      [
        -341,
        -278
      ],
      [
        -451,
        -73
      ],
      [
        -54,
        -233
      ],
      [
        -178,
        14
      ],
      [
        -179,
        257
      ],
      [
        -69,
        -81
      ],
      [
        100,
        -154
      ],
      [
        -205,
        -4
      ],
      [
        -24,
        -235
      ],
      [
        -65,
        -82
      ],
      [
        -138,
        -46
      ],
      [
        -259,
        90
      ],
      [
        -184,
        -140
      ],
      [
        -306,
        264
      ],
      [
        -255,
        -6
      ],
      [
        -203,
        294
      ],
      [
        -90,
        40
      ],
      [
        -94,
        -38
      ],
      [
        -68,
        -170
      ],
      [
        -228,
        4
      ],
      [
        -73,
        -155
      ]
    ],
    [
      [
        14472,
        18632
      ],
      [
        -254,
        89
      ],
      [
        -133,
        -261
      ],
      [
        -66,
        106
      ],
      [
        -220,
        -120
      ],
      [
        -179,
        60
      ],
      [
        -189,
        -158
      ],
      [
        -569,
        17
      ],
      [
        -200,
        75
      ],
      [
        -133,
        181
      ],
      [
        -45,
        172
      ],
      [
        66,
        256
      ]
    ],
    [
      [
        22745,
        23705
      ],
      [
        238,
        69
      ],
      [
        152,
        -305
      ],
      [
        188,
        76
      ],
      [
        194,
        -125
      ],
      [
        167,
        108
      ],
      [
        -1,
        387
      ],
      [
        263,
        35
      ],
      [
        209,
        -99
      ],
      [
        255,
        -338
      ],
      [
        -238,
        -100
      ],
      [
        -49,
        122
      ],
      [
        -92,
        -25
      ],
      [
        60,
        -363
      ],
      [
        -392,
        -186
      ],
      [
        -8,
        -341
      ],
      [
        -378,
        -348
      ],
      [
        124,
        -337
      ],
      [
        61,
        -50
      ],
      [
        156,
        71
      ],
      [
        157,
        -179
      ],
      [
        362,
        178
      ],
      [
        33,
        -123
      ],
      [
        329,
        -4
      ],
      [
        137,
        -123
      ],
      [
        -82,
        -427
      ],
      [
        -45,
        -50
      ],
      [
        -183,
        65
      ],
      [
        -157,
        -453
      ],
      [
        -66,
        -519
      ],
      [
        208,
        -77
      ],
      [
        -425,
        -458
      ],
      [
        77,
        -283
      ],
      [
        -126,
        -313
      ],
      [
        182,
        -112
      ],
      [
        -182,
        -405
      ]
    ],
    [
      [
        14472,
        18632
      ],
      [
        119,
        -4
      ],
      [
        -171,
        -53
      ],
      [
        -37,
        -198
      ],
      [
        11,
        -570
      ],
      [
        91,
        -272
      ],
      [
        165,
        -73
      ],
      [
        218,
        35
      ],
      [
        295,
        425
      ],
      [
        103,
        43
      ],
      [
        182,
        -250
      ],
      [
        -48,
        -322
      ],
      [
        501,
        -133
      ],
      [
        -51,
        -322
      ],
      [
        304,
        -67
      ],
      [
        237,
        -383
      ],
      [
        277,
        28
      ],
      [
        -26,
        -392
      ],
      [
        234,
        275
      ],
      [
        533,
        60
      ],
      [
        98,
        -107
      ],
      [
        423,
        3
      ],
      [
        45,
        -79
      ],
      [
        -26,
        -381
      ],
      [
        310,
        169
      ],
      [
        -12,
        -143
      ],
      [
        138,
        -66
      ],
      [
        565,
        252
      ]
    ],
    [
      [
        18950,
        16107
      ],
      [
        -167,
        -761
      ],
      [
        337,
        88
      ],
      [
        -73,
        -143
      ],
      [
        116,
        -166
      ],
      [
        -126,
        -360
      ],
      [
        -127,
        -24
      ],
      [
        91,
        -109
      ],
      [
        -89,
        -94
      ],
      [
        407,
        -255
      ],
      [
        -140,
        -323
      ],
      [
        -150,
        -48
      ],
      [
        194,
        -239
      ],
      [
        -228,
        -396
      ],
      [
        60,
        -579
      ],
      [
        -635,
        -109
      ],
      [
        -171,
        231
      ],
      [
        -262,
        -25
      ],
      [
        -191,
        -348
      ],
      [
        -521,
        77
      ],
      [
        -77,
        -289
      ],
      [
        -169,
        9
      ],
      [
        -120,
        -231
      ],
      [
        -316,
        -23
      ],
      [
        -372,
        -288
      ],
      [
        154,
        -221
      ],
      [
        343,
        -214
      ],
      [
        72,
        4
      ],
      [
        174,
        212
      ],
      [
        198,
        -46
      ],
      [
        134,
        -109
      ],
      [
        -113,
        -494
      ],
      [
        76,
        -221
      ],
      [
        -343,
        -278
      ],
      [
        360,
        -662
      ],
      [
        -123,
        -263
      ],
      [
        8,
        -618
      ],
      [
        41,
        -252
      ],
      [
        152,
        -57
      ],
      [
        76,
        -802
      ],
      [
        274,
        -592
      ],
      [
        -126,
        -327
      ]
    ],
    [
      [
        17578,
        6762
      ],
      [
        -154,
        35
      ],
      [
        -226,
        147
      ],
      [
        -343,
        27
      ],
      [
        -267,
        224
      ],
      [
        -980,
        -71
      ],
      [
        -202,
        -17
      ],
      [
        -120,
        222
      ],
      [
        -349,
        105
      ],
      [
        27,
        295
      ],
      [
        -128,
        245
      ],
      [
        152,
        389
      ],
      [
        70,
        72
      ],
      [
        298,
        67
      ],
      [
        301,
        308
      ],
      [
        -34,
        204
      ],
      [
        -231,
        409
      ],
      [
        26,
        197
      ],
      [
        -66,
        141
      ],
      [
        -285,
        23
      ],
      [
        -190,
        -124
      ],
      [
        -115,
        51
      ],
      [
        32,
        222
      ],
      [
        195,
        296
      ],
      [
        34,
        715
      ],
      [
        311,
        452
      ],
      [
        216,
        199
      ],
      [
        -28,
        291
      ],
      [
        -266,
        110
      ],
      [
        -144,
        154
      ],
      [
        -66,
        -94
      ],
      [
        23,
        -313
      ],
      [
        -227,
        -28
      ],
      [
        -123,
        289
      ],
      [
        -47,
        330
      ],
      [
        -165,
        169
      ],
      [
        -227,
        48
      ],
      [
        -434,
        628
      ],
      [
        -28,
        -9
      ],
      [
        -285,
        -91
      ],
      [
        -77,
        -136
      ],
      [
        -232,
        -8
      ],
      [
        -519,
        -256
      ],
      [
        -220,
        56
      ],
      [
        -462,
        336
      ],
      [
        -853,
        -78
      ],
      [
        -147,
        -141
      ],
      [
        -70,
        -393
      ],
      [
        -163,
        54
      ],
      [
        -52,
        -158
      ],
      [
        -176,
        138
      ],
      [
        -248,
        771
      ],
      [
        140,
        494
      ],
      [
        -160,
        837
      ],
      [
        -134,
        207
      ],
      [
        -334,
        466
      ],
      [
        -306,
        -53
      ],
      [
        -125,
        119
      ],
      [
        -468,
        -191
      ],
      [
        -136,
        8
      ],
      [
        -30,
        135
      ],
      [
        154,
        354
      ],
      [
        -98,
        194
      ],
      [
        -313,
        -86
      ],
      [
        -315,
        -343
      ],
      [
        -287,
        -17
      ],
      [
        -309,
        -108
      ],
      [
        -801,
        573
      ],
      [
        -67,
        146
      ],
      [
        -2,
        901
      ],
      [
        -263,
        574
      ],
      [
        -64,
        367
      ],
      [
        40,
        199
      ],
      [
        114,
        111
      ],
      [
        -65,
        286
      ],
      [
        -111,
        199
      ],
      [
        -316,
        129
      ],
      [
        -111,
        323
      ],
      [
        -158,
        247
      ]
    ],
    [
      [
        5789,
        19335
      ],
      [
        421,
        225
      ],
      [
        386,
        -231
      ],
      [
        399,
        64
      ],
      [
        200,
        -298
      ],
      [
        -14,
        -211
      ],
      [
        232,
        -178
      ],
      [
        101,
        -8
      ],
      [
        420,
        550
      ],
      [
        260,
        35
      ],
      [
        -2,
        128
      ],
      [
        265,
        148
      ]
    ],
    [
      [
        2857,
        18670
      ],
      [
        -191,
        636
      ],
      [
        250,
        161
      ],
      [
        62,
        19
      ],
      [
        134,
        -129
      ],
      [
        267,
        55
      ],
      [
        41,
        143
      ],
      [
        355,
        152
      ],
      [
        -193,
        238
      ],
      [
        9,
        69
      ],
      [
        546,
        230
      ],
      [
        146,
        -100
      ],
      [
        89,
        -568
      ]
    ],
    [
      [
        4372,
        19576
      ],
      [
        -214,
        -100
      ],
      [
        -254,
        -189
      ],
      [
        -268,
        -31
      ],
      [
        -264,
        -562
      ],
      [
        -113,
        -159
      ],
      [
        -109,
        -26
      ],
      [
        -293,
        161
      ]
    ],
    [
      [
        31366,
        19410
      ],
      [
        51,
        -37
      ],
      [
        27,
        5
      ],
      [
        44,
        9
      ],
      [
        97,
        21
      ],
      [
        13,
        2
      ],
      [
        167,
        35
      ],
      [
        15,
        3
      ],
      [
        96,
        20
      ],
      [
        6,
        1
      ],
      [
        51,
        10
      ],
      [
        10,
        -6
      ],
      [
        13,
        1
      ],
      [
        112,
        -26
      ],
      [
        91,
        -27
      ],
      [
        27,
        -8
      ],
      [
        117,
        -22
      ],
      [
        75,
        14
      ],
      [
        1,
        -10
      ],
      [
        42,
        5
      ],
      [
        5,
        -41
      ],
      [
        31,
        -92
      ],
      [
        84,
        -243
      ],
      [
        39,
        -113
      ],
      [
        -2,
        33
      ],
      [
        61,
        -53
      ],
      [
        135,
        -55
      ],
      [
        104,
        -42
      ],
      [
        175,
        15
      ],
      [
        -1,
        19
      ],
      [
        47,
        -4
      ],
      [
        12,
        -10
      ],
      [
        -1,
        9
      ],
      [
        147,
        -14
      ],
      [
        91,
        -82
      ],
      [
        78,
        -70
      ],
      [
        286,
        -492
      ],
      [
        231,
        -285
      ],
      [
        -40,
        -89
      ],
      [
        77,
        -68
      ],
      [
        3,
        -57
      ],
      [
        -57,
        -4
      ],
      [
        -48,
        -54
      ],
      [
        -7,
        -8
      ],
      [
        -3,
        58
      ],
      [
        -58,
        -4
      ],
      [
        80,
        -105
      ],
      [
        34,
        -175
      ],
      [
        9,
        -47
      ],
      [
        3,
        -17
      ],
      [
        210,
        137
      ],
      [
        20,
        13
      ],
      [
        14,
        -11
      ],
      [
        103,
        7
      ],
      [
        178,
        -103
      ],
      [
        285,
        18
      ],
      [
        60,
        -54
      ],
      [
        2,
        -27
      ],
      [
        117,
        -58
      ],
      [
        -252,
        -375
      ],
      [
        -92,
        22
      ],
      [
        -89,
        -100
      ],
      [
        4,
        -57
      ],
      [
        -118,
        49
      ],
      [
        0,
        9
      ],
      [
        -75,
        -114
      ],
      [
        -55,
        -42
      ],
      [
        -32,
        -36
      ],
      [
        -18,
        -1
      ],
      [
        -39,
        -3
      ],
      [
        1,
        -26
      ],
      [
        5,
        -88
      ],
      [
        -111,
        -65
      ],
      [
        -57,
        -4
      ],
      [
        -37,
        -41
      ],
      [
        -32,
        -144
      ],
      [
        55,
        -183
      ],
      [
        26,
        -87
      ],
      [
        64,
        -57
      ],
      [
        213,
        -190
      ],
      [
        127,
        -228
      ],
      [
        157,
        -15
      ],
      [
        58,
        -6
      ],
      [
        2,
        -40
      ],
      [
        57,
        4
      ],
      [
        4,
        -57
      ],
      [
        57,
        3
      ],
      [
        -4,
        57
      ],
      [
        18,
        20
      ],
      [
        36,
        41
      ],
      [
        56,
        -50
      ],
      [
        4,
        -4
      ],
      [
        22,
        1
      ],
      [
        35,
        2
      ],
      [
        0,
        -5
      ],
      [
        194,
        -19
      ],
      [
        9,
        -1
      ],
      [
        43,
        21
      ],
      [
        109,
        54
      ],
      [
        64,
        -63
      ],
      [
        60,
        -60
      ],
      [
        16,
        -16
      ],
      [
        28,
        -110
      ],
      [
        44,
        -170
      ],
      [
        28,
        -110
      ],
      [
        3,
        -2
      ],
      [
        0,
        -9
      ],
      [
        14,
        -51
      ],
      [
        199,
        -187
      ],
      [
        26,
        30
      ],
      [
        60,
        -54
      ],
      [
        4,
        -60
      ],
      [
        13,
        -13
      ],
      [
        -10,
        -34
      ],
      [
        -107,
        -354
      ],
      [
        -1,
        -248
      ],
      [
        -203,
        -216
      ],
      [
        -7,
        -160
      ],
      [
        0,
        -7
      ],
      [
        48,
        -61
      ],
      [
        177,
        -164
      ],
      [
        3,
        -64
      ],
      [
        48,
        -60
      ],
      [
        12,
        -17
      ],
      [
        22,
        -27
      ],
      [
        36,
        2
      ],
      [
        3,
        -51
      ],
      [
        4,
        -6
      ],
      [
        52,
        2
      ],
      [
        118,
        -110
      ],
      [
        6,
        -113
      ],
      [
        56,
        2
      ],
      [
        3,
        -57
      ],
      [
        56,
        2
      ],
      [
        -47,
        -172
      ],
      [
        -109,
        -60
      ],
      [
        -56,
        -2
      ],
      [
        -36,
        33
      ],
      [
        -21,
        -10
      ],
      [
        -204,
        -93
      ],
      [
        -14,
        -1
      ],
      [
        0,
        -6
      ],
      [
        -142,
        153
      ],
      [
        -93,
        -16
      ],
      [
        -2,
        26
      ],
      [
        -27,
        -31
      ],
      [
        -28,
        -5
      ],
      [
        -2,
        32
      ],
      [
        -33,
        -37
      ],
      [
        -21,
        -24
      ],
      [
        -84,
        -6
      ],
      [
        -87,
        -5
      ],
      [
        5,
        -92
      ],
      [
        5,
        -80
      ],
      [
        -45,
        -3
      ],
      [
        -70,
        -5
      ],
      [
        9,
        -155
      ],
      [
        1,
        -16
      ],
      [
        -7,
        0
      ],
      [
        -50,
        -4
      ],
      [
        3,
        -57
      ],
      [
        -57,
        -4
      ],
      [
        10,
        -171
      ],
      [
        4,
        -3
      ],
      [
        -44,
        -115
      ],
      [
        -9,
        -24
      ],
      [
        5,
        -90
      ],
      [
        -196,
        -14
      ],
      [
        -114,
        -36
      ],
      [
        -28,
        -32
      ],
      [
        -100,
        -7
      ],
      [
        -91,
        -28
      ],
      [
        -148,
        -46
      ],
      [
        -7,
        -2
      ],
      [
        -34,
        -59
      ],
      [
        -63,
        -109
      ],
      [
        -4,
        -7
      ],
      [
        -203,
        -111
      ],
      [
        6,
        -22
      ],
      [
        175,
        -700
      ],
      [
        -38,
        -36
      ],
      [
        -29,
        -24
      ],
      [
        -122,
        -101
      ],
      [
        -11,
        -2
      ],
      [
        -92,
        -21
      ],
      [
        -16,
        -3
      ],
      [
        5,
        -94
      ],
      [
        -56,
        -2
      ],
      [
        -47,
        43
      ],
      [
        -72,
        -204
      ],
      [
        -14,
        -41
      ],
      [
        -18,
        -51
      ],
      [
        170,
        -78
      ],
      [
        -34,
        -189
      ],
      [
        -73,
        2
      ],
      [
        2,
        -52
      ],
      [
        -116,
        -3
      ],
      [
        0,
        -3
      ],
      [
        -18,
        8
      ],
      [
        -109,
        51
      ],
      [
        1,
        3
      ],
      [
        43,
        102
      ],
      [
        10,
        37
      ],
      [
        30,
        65
      ],
      [
        -10,
        43
      ],
      [
        -36,
        145
      ],
      [
        -125,
        83
      ],
      [
        -52,
        35
      ],
      [
        -195,
        24
      ],
      [
        -30,
        -221
      ],
      [
        -63,
        -26
      ],
      [
        -98,
        17
      ],
      [
        -115,
        40
      ],
      [
        -40,
        17
      ],
      [
        -78,
        45
      ],
      [
        -40,
        24
      ],
      [
        -60,
        246
      ]
    ],
    [
      [
        32546,
        10524
      ],
      [
        -9,
        35
      ],
      [
        -39,
        167
      ],
      [
        131,
        157
      ],
      [
        -205,
        43
      ],
      [
        -42,
        171
      ],
      [
        52,
        1435
      ],
      [
        -300,
        163
      ],
      [
        -16,
        132
      ],
      [
        -1139,
        262
      ],
      [
        -82,
        -283
      ],
      [
        173,
        -155
      ],
      [
        -209,
        -538
      ],
      [
        327,
        -51
      ],
      [
        -61,
        -151
      ],
      [
        -595,
        -87
      ],
      [
        -61,
        -151
      ],
      [
        -63,
        149
      ],
      [
        -154,
        51
      ],
      [
        -564,
        -92
      ],
      [
        252,
        567
      ],
      [
        -253,
        66
      ],
      [
        -152,
        270
      ],
      [
        -10,
        170
      ],
      [
        163,
        385
      ],
      [
        -474,
        1
      ],
      [
        45,
        184
      ],
      [
        -312,
        -20
      ],
      [
        -508,
        499
      ],
      [
        -319,
        -159
      ],
      [
        -156,
        25
      ],
      [
        -52,
        49
      ],
      [
        29,
        139
      ],
      [
        -158,
        33
      ],
      [
        -87,
        304
      ],
      [
        -376,
        -261
      ],
      [
        -408,
        335
      ],
      [
        -124,
        -7
      ],
      [
        -58,
        -107
      ],
      [
        189,
        -351
      ],
      [
        -313,
        -311
      ]
    ],
    [
      [
        26608,
        13592
      ],
      [
        -399,
        143
      ],
      [
        -515,
        -363
      ],
      [
        -130,
        189
      ],
      [
        11,
        285
      ],
      [
        -466,
        133
      ],
      [
        -116,
        199
      ],
      [
        147,
        303
      ],
      [
        -173,
        410
      ],
      [
        -204,
        216
      ],
      [
        -318,
        -134
      ],
      [
        -103,
        184
      ],
      [
        47,
        135
      ],
      [
        -186,
        -29
      ],
      [
        -65,
        244
      ],
      [
        127,
        128
      ],
      [
        -224,
        -110
      ],
      [
        -128,
        25
      ],
      [
        -141,
        363
      ],
      [
        -524,
        31
      ],
      [
        177,
        139
      ],
      [
        -241,
        741
      ],
      [
        -456,
        453
      ],
      [
        32,
        371
      ]
    ],
    [
      [
        22760,
        17648
      ],
      [
        181,
        352
      ],
      [
        -10,
        457
      ],
      [
        149,
        110
      ],
      [
        -232,
        346
      ],
      [
        224,
        125
      ],
      [
        31,
        285
      ]
    ],
    [
      [
        23873,
        18673
      ],
      [
        625,
        -193
      ],
      [
        120,
        152
      ],
      [
        -104,
        254
      ],
      [
        559,
        -75
      ],
      [
        68,
        147
      ],
      [
        68,
        -176
      ],
      [
        302,
        194
      ],
      [
        298,
        -170
      ],
      [
        46,
        175
      ],
      [
        186,
        173
      ],
      [
        433,
        152
      ],
      [
        127,
        -57
      ],
      [
        116,
        -303
      ],
      [
        252,
        -102
      ],
      [
        210,
        22
      ],
      [
        74,
        273
      ],
      [
        185,
        -210
      ],
      [
        150,
        38
      ],
      [
        253,
        230
      ],
      [
        -18,
        252
      ],
      [
        813,
        252
      ],
      [
        460,
        481
      ],
      [
        323,
        17
      ]
    ],
    [
      [
        29419,
        20199
      ],
      [
        44,
        -26
      ],
      [
        42,
        -26
      ],
      [
        8,
        -56
      ],
      [
        19,
        -147
      ],
      [
        7,
        -50
      ],
      [
        -7,
        -20
      ],
      [
        12,
        -26
      ],
      [
        -16,
        -62
      ],
      [
        -40,
        -82
      ],
      [
        -35,
        -122
      ],
      [
        -32,
        -69
      ],
      [
        -4,
        -10
      ],
      [
        -4,
        -8
      ],
      [
        -1,
        -14
      ],
      [
        0,
        -16
      ]
    ],
    [
      [
        29412,
        19465
      ],
      [
        -5,
        -101
      ],
      [
        268,
        -122
      ],
      [
        151,
        149
      ],
      [
        141,
        -147
      ],
      [
        241,
        68
      ],
      [
        398,
        -549
      ],
      [
        336,
        50
      ],
      [
        226,
        -121
      ],
      [
        82,
        36
      ],
      [
        218,
        349
      ],
      [
        -188,
        250
      ],
      [
        86,
        83
      ]
    ],
    [
      [
        29412,
        19465
      ],
      [
        32,
        -35
      ],
      [
        8,
        -9
      ],
      [
        15,
        4
      ],
      [
        2,
        0
      ],
      [
        17,
        5
      ],
      [
        73,
        60
      ],
      [
        108,
        -1
      ],
      [
        63,
        0
      ],
      [
        69,
        0
      ],
      [
        5,
        5
      ],
      [
        12,
        14
      ],
      [
        191,
        224
      ],
      [
        14,
        4
      ],
      [
        50,
        13
      ],
      [
        36,
        34
      ],
      [
        78,
        49
      ],
      [
        3,
        -2
      ],
      [
        88,
        -76
      ],
      [
        30,
        -77
      ],
      [
        20,
        -41
      ],
      [
        21,
        -42
      ],
      [
        25,
        5
      ],
      [
        187,
        -150
      ],
      [
        9,
        2
      ],
      [
        52,
        18
      ],
      [
        120,
        40
      ],
      [
        50,
        -10
      ],
      [
        46,
        -9
      ],
      [
        122,
        -25
      ],
      [
        6,
        3
      ],
      [
        22,
        12
      ],
      [
        210,
        111
      ],
      [
        11,
        -12
      ],
      [
        10,
        -11
      ],
      [
        149,
        -158
      ]
    ],
    [
      [
        25186,
        27187
      ],
      [
        224,
        81
      ],
      [
        137,
        -36
      ],
      [
        138,
        -3
      ],
      [
        175,
        -4
      ],
      [
        200,
        -5
      ],
      [
        28,
        18
      ],
      [
        84,
        54
      ],
      [
        29,
        18
      ],
      [
        80,
        50
      ],
      [
        592,
        -181
      ],
      [
        34,
        38
      ],
      [
        35,
        41
      ],
      [
        46,
        78
      ],
      [
        81,
        40
      ],
      [
        59,
        76
      ],
      [
        85,
        51
      ],
      [
        112,
        26
      ],
      [
        111,
        64
      ],
      [
        47,
        79
      ],
      [
        36,
        66
      ],
      [
        11,
        1
      ],
      [
        35,
        3
      ],
      [
        16,
        2
      ],
      [
        35,
        -16
      ],
      [
        123,
        -57
      ],
      [
        32,
        -37
      ],
      [
        330,
        -372
      ],
      [
        82,
        -581
      ],
      [
        97,
        -114
      ],
      [
        59,
        -70
      ],
      [
        359,
        -121
      ],
      [
        343,
        -142
      ],
      [
        35,
        -207
      ],
      [
        509,
        -79
      ],
      [
        72,
        21
      ],
      [
        51,
        -11
      ],
      [
        128,
        64
      ],
      [
        40,
        20
      ],
      [
        81,
        40
      ],
      [
        21,
        -6
      ],
      [
        96,
        -28
      ],
      [
        13,
        -4
      ],
      [
        39,
        -20
      ],
      [
        135,
        -71
      ],
      [
        11,
        -6
      ],
      [
        -1,
        -3
      ],
      [
        -9,
        -52
      ],
      [
        7,
        -15
      ],
      [
        16,
        -33
      ],
      [
        -1,
        -2
      ],
      [
        -17,
        -39
      ],
      [
        -15,
        -36
      ],
      [
        46,
        -57
      ],
      [
        6,
        -7
      ],
      [
        -32,
        -86
      ],
      [
        30,
        4
      ],
      [
        191,
        22
      ],
      [
        25,
        2
      ],
      [
        49,
        6
      ],
      [
        40,
        5
      ],
      [
        31,
        3
      ],
      [
        10,
        42
      ],
      [
        49,
        52
      ],
      [
        34,
        -2
      ],
      [
        23,
        -2
      ],
      [
        3,
        -5
      ],
      [
        27,
        -50
      ],
      [
        16,
        -72
      ],
      [
        40,
        -95
      ],
      [
        70,
        -53
      ],
      [
        76,
        -72
      ],
      [
        -3,
        -3
      ],
      [
        -47,
        -54
      ],
      [
        -46,
        -50
      ],
      [
        -46,
        -63
      ],
      [
        -52,
        -32
      ],
      [
        -79,
        -18
      ],
      [
        -45,
        -37
      ],
      [
        -35,
        -56
      ],
      [
        -39,
        -75
      ],
      [
        -12,
        -91
      ],
      [
        18,
        -23
      ],
      [
        15,
        -20
      ],
      [
        14,
        -6
      ],
      [
        52,
        -4
      ],
      [
        39,
        -22
      ],
      [
        24,
        -14
      ],
      [
        31,
        -77
      ],
      [
        -18,
        -39
      ],
      [
        2,
        -18
      ],
      [
        -81,
        -66
      ],
      [
        -29,
        -24
      ],
      [
        -58,
        11
      ],
      [
        -51,
        9
      ],
      [
        -51,
        -24
      ],
      [
        -25,
        -12
      ],
      [
        -23,
        -69
      ],
      [
        30,
        -68
      ],
      [
        20,
        -60
      ],
      [
        -36,
        -66
      ],
      [
        -23,
        -57
      ],
      [
        9,
        -55
      ],
      [
        11,
        -83
      ],
      [
        -38,
        -21
      ],
      [
        -1,
        0
      ],
      [
        -14,
        -7
      ],
      [
        -49,
        15
      ],
      [
        -20,
        7
      ],
      [
        -33,
        14
      ],
      [
        -25,
        10
      ],
      [
        -12,
        -20
      ],
      [
        -9,
        -16
      ],
      [
        -11,
        -20
      ],
      [
        -12,
        -63
      ],
      [
        -1,
        -5
      ],
      [
        -35,
        -79
      ],
      [
        -52,
        -107
      ],
      [
        -43,
        -115
      ],
      [
        -1,
        -11
      ],
      [
        -4,
        -63
      ],
      [
        55,
        -42
      ],
      [
        4,
        -3
      ],
      [
        43,
        -72
      ],
      [
        -5,
        -11
      ],
      [
        -31,
        -63
      ],
      [
        -4,
        -16
      ],
      [
        -22,
        -83
      ],
      [
        -5,
        -40
      ],
      [
        32,
        -3
      ],
      [
        -72,
        -290
      ],
      [
        -133,
        -167
      ],
      [
        -56,
        -70
      ],
      [
        -161,
        -200
      ],
      [
        -7,
        -62
      ],
      [
        56,
        -55
      ],
      [
        63,
        -4
      ],
      [
        45,
        23
      ],
      [
        10,
        5
      ],
      [
        9,
        5
      ],
      [
        70,
        17
      ],
      [
        49,
        -46
      ],
      [
        1,
        -52
      ],
      [
        -35,
        -71
      ],
      [
        -24,
        -42
      ],
      [
        -33,
        -61
      ],
      [
        -57,
        -88
      ],
      [
        -86,
        -179
      ],
      [
        -5,
        -18
      ],
      [
        -31,
        -123
      ],
      [
        -34,
        -71
      ],
      [
        -12,
        -26
      ],
      [
        -18,
        -2
      ],
      [
        -136,
        -16
      ],
      [
        -30,
        -24
      ],
      [
        -4,
        -3
      ],
      [
        -53,
        -128
      ],
      [
        -3,
        -15
      ],
      [
        -32,
        -74
      ],
      [
        -4,
        -10
      ],
      [
        -4,
        -8
      ],
      [
        -9,
        -22
      ],
      [
        -4,
        -2
      ],
      [
        -21,
        -41
      ],
      [
        -15,
        -58
      ],
      [
        -2,
        -8
      ],
      [
        -1,
        -5
      ],
      [
        -54,
        -26
      ],
      [
        -111,
        -1
      ],
      [
        -6,
        -5
      ],
      [
        -82,
        -58
      ],
      [
        -71,
        -49
      ],
      [
        -12,
        -9
      ],
      [
        -18,
        -90
      ],
      [
        0,
        -1
      ],
      [
        -5,
        -27
      ],
      [
        -14,
        -74
      ],
      [
        -4,
        -92
      ],
      [
        -1,
        -32
      ],
      [
        13,
        -105
      ],
      [
        1,
        -17
      ],
      [
        7,
        -111
      ],
      [
        3,
        -11
      ],
      [
        24,
        -102
      ],
      [
        74,
        -117
      ],
      [
        81,
        -31
      ],
      [
        26,
        -5
      ],
      [
        6,
        -2
      ],
      [
        182,
        -167
      ]
    ],
    [
      [
        32546,
        10524
      ],
      [
        -40,
        -15
      ],
      [
        -173,
        -63
      ],
      [
        -116,
        -17
      ],
      [
        -18,
        1
      ],
      [
        -171,
        -65
      ],
      [
        -20,
        -8
      ],
      [
        -127,
        -556
      ],
      [
        -164,
        -131
      ],
      [
        -322,
        -254
      ],
      [
        -9,
        -24
      ],
      [
        -19,
        -122
      ],
      [
        -48,
        -91
      ],
      [
        -24,
        -118
      ],
      [
        -18,
        -131
      ],
      [
        -60,
        -32
      ],
      [
        -80,
        -35
      ],
      [
        -103,
        -99
      ],
      [
        -45,
        -90
      ],
      [
        2,
        -23
      ],
      [
        22,
        -214
      ],
      [
        -58,
        -245
      ],
      [
        -91,
        -155
      ],
      [
        -111,
        -74
      ],
      [
        -57,
        -38
      ],
      [
        -16,
        -100
      ],
      [
        14,
        -111
      ],
      [
        70,
        -76
      ],
      [
        76,
        -115
      ],
      [
        1,
        -58
      ],
      [
        0,
        -52
      ],
      [
        -60,
        -68
      ],
      [
        -90,
        -23
      ],
      [
        -100,
        -23
      ],
      [
        -10,
        -120
      ],
      [
        -45,
        -60
      ],
      [
        -89,
        39
      ],
      [
        -57,
        13
      ],
      [
        -35,
        -59
      ],
      [
        -99,
        -12
      ],
      [
        -25,
        -141
      ],
      [
        9,
        -94
      ],
      [
        -11,
        -92
      ],
      [
        -53,
        -95
      ],
      [
        -35,
        -119
      ],
      [
        -20,
        -73
      ],
      [
        -64,
        -118
      ],
      [
        -58,
        -14
      ],
      [
        -89,
        -135
      ],
      [
        9,
        -64
      ],
      [
        126,
        -78
      ],
      [
        143,
        -75
      ],
      [
        116,
        -87
      ],
      [
        16,
        -79
      ],
      [
        6,
        -26
      ],
      [
        -28,
        26
      ],
      [
        -40,
        38
      ],
      [
        6,
        -36
      ],
      [
        4,
        -20
      ],
      [
        4,
        -2
      ],
      [
        -3,
        -5
      ],
      [
        -54,
        -96
      ],
      [
        -16,
        -13
      ],
      [
        -14,
        1
      ],
      [
        -145,
        6
      ],
      [
        -7,
        -18
      ],
      [
        8,
        -88
      ],
      [
        13,
        -60
      ],
      [
        -17,
        -47
      ],
      [
        -41,
        -6
      ],
      [
        -30,
        -5
      ],
      [
        30,
        -21
      ],
      [
        0,
        -122
      ],
      [
        -26,
        1
      ],
      [
        -3,
        -79
      ],
      [
        -39,
        -29
      ],
      [
        34,
        -108
      ],
      [
        17,
        -118
      ],
      [
        -35,
        -88
      ],
      [
        51,
        -68
      ],
      [
        11,
        -14
      ],
      [
        25,
        -131
      ],
      [
        6,
        -126
      ],
      [
        232,
        -2
      ],
      [
        4,
        -3
      ],
      [
        107,
        -106
      ],
      [
        311,
        -679
      ],
      [
        44,
        -262
      ],
      [
        -1,
        -38
      ],
      [
        155,
        -9
      ],
      [
        33,
        13
      ],
      [
        80,
        30
      ],
      [
        80,
        -12
      ],
      [
        74,
        -78
      ],
      [
        54,
        -93
      ],
      [
        65,
        -93
      ],
      [
        -25,
        -26
      ],
      [
        -51,
        -55
      ],
      [
        -69,
        -86
      ],
      [
        -24,
        -129
      ],
      [
        6,
        -102
      ],
      [
        63,
        -100
      ],
      [
        105,
        -68
      ],
      [
        102,
        -46
      ],
      [
        108,
        -66
      ],
      [
        -41,
        -109
      ],
      [
        -11,
        -70
      ],
      [
        9,
        -118
      ],
      [
        -8,
        -114
      ],
      [
        -92,
        -6
      ],
      [
        -122,
        -7
      ],
      [
        -34,
        -94
      ],
      [
        7,
        -69
      ],
      [
        3,
        -25
      ],
      [
        -64,
        -97
      ],
      [
        -42,
        -104
      ],
      [
        7,
        -117
      ],
      [
        -86,
        -64
      ],
      [
        -75,
        -64
      ],
      [
        -18,
        -105
      ],
      [
        154,
        -61
      ],
      [
        -1,
        -8
      ],
      [
        55,
        13
      ],
      [
        2,
        -160
      ],
      [
        -36,
        -45
      ],
      [
        -24,
        -32
      ],
      [
        -102,
        -97
      ],
      [
        -63,
        -82
      ],
      [
        -67,
        -59
      ],
      [
        -90,
        -79
      ],
      [
        -53,
        24
      ],
      [
        -10,
        -9
      ],
      [
        -5,
        -1
      ],
      [
        -176,
        -11
      ],
      [
        -398,
        142
      ],
      [
        -99,
        -45
      ],
      [
        -97,
        -205
      ],
      [
        -93,
        -10
      ],
      [
        -331,
        -38
      ],
      [
        -271,
        141
      ],
      [
        -196,
        1
      ],
      [
        -282,
        -310
      ],
      [
        -98,
        -330
      ],
      [
        -452,
        312
      ],
      [
        -132,
        -33
      ],
      [
        -187,
        -220
      ],
      [
        -242,
        -34
      ],
      [
        -159,
        -28
      ],
      [
        -138,
        -145
      ],
      [
        -150,
        279
      ],
      [
        136,
        289
      ],
      [
        -161,
        219
      ],
      [
        -5,
        211
      ],
      [
        -253,
        565
      ],
      [
        -480,
        358
      ],
      [
        -96,
        72
      ],
      [
        -152,
        -11
      ],
      [
        -169,
        -171
      ],
      [
        -145,
        12
      ],
      [
        -59,
        270
      ],
      [
        225,
        314
      ],
      [
        -590,
        611
      ],
      [
        -117,
        3
      ],
      [
        -88,
        -78
      ],
      [
        -275,
        22
      ],
      [
        -112,
        96
      ],
      [
        -307,
        -11
      ],
      [
        -138,
        304
      ],
      [
        -35,
        1
      ],
      [
        -91,
        5
      ],
      [
        -69,
        -83
      ],
      [
        -114,
        91
      ],
      [
        -111,
        416
      ],
      [
        -154,
        221
      ],
      [
        -537,
        200
      ],
      [
        -489,
        499
      ],
      [
        -137,
        -7
      ]
    ],
    [
      [
        22659,
        4697
      ],
      [
        42,
        263
      ],
      [
        121,
        37
      ],
      [
        -80,
        296
      ],
      [
        40,
        135
      ],
      [
        704,
        537
      ],
      [
        -156,
        166
      ],
      [
        239,
        240
      ],
      [
        471,
        199
      ],
      [
        -203,
        215
      ],
      [
        34,
        344
      ],
      [
        -274,
        150
      ],
      [
        -86,
        209
      ],
      [
        -399,
        -85
      ],
      [
        -100,
        53
      ],
      [
        -121,
        503
      ],
      [
        -228,
        236
      ],
      [
        178,
        -5
      ],
      [
        65,
        239
      ],
      [
        86,
        -95
      ],
      [
        91,
        34
      ],
      [
        307,
        337
      ],
      [
        99,
        261
      ],
      [
        -82,
        88
      ],
      [
        139,
        593
      ],
      [
        54,
        -432
      ],
      [
        200,
        -73
      ],
      [
        879,
        65
      ],
      [
        200,
        44
      ],
      [
        255,
        189
      ],
      [
        251,
        -27
      ],
      [
        48,
        165
      ],
      [
        -240,
        235
      ],
      [
        268,
        91
      ],
      [
        87,
        279
      ],
      [
        -333,
        409
      ],
      [
        14,
        157
      ],
      [
        -113,
        1
      ],
      [
        102,
        153
      ],
      [
        -362,
        212
      ],
      [
        175,
        129
      ],
      [
        270,
        -19
      ],
      [
        -24,
        182
      ],
      [
        210,
        150
      ],
      [
        103,
        10
      ],
      [
        98,
        -135
      ],
      [
        664,
        451
      ],
      [
        258,
        284
      ],
      [
        9,
        234
      ],
      [
        -96,
        245
      ],
      [
        -218,
        -15
      ],
      [
        -116,
        -178
      ],
      [
        -73,
        80
      ],
      [
        510,
        400
      ],
      [
        -133,
        183
      ],
      [
        197,
        277
      ],
      [
        -82,
        199
      ]
    ],
    [
      [
        22659,
        4697
      ],
      [
        -164,
        -9
      ],
      [
        -353,
        -199
      ],
      [
        -394,
        87
      ],
      [
        -182,
        -31
      ],
      [
        5,
        117
      ],
      [
        173,
        291
      ],
      [
        -73,
        323
      ],
      [
        -105,
        102
      ],
      [
        -11,
        240
      ],
      [
        291,
        562
      ],
      [
        22,
        159
      ],
      [
        -43,
        162
      ],
      [
        -347,
        449
      ],
      [
        -340,
        71
      ],
      [
        -160,
        119
      ],
      [
        -45,
        269
      ],
      [
        234,
        141
      ],
      [
        64,
        180
      ],
      [
        25,
        435
      ],
      [
        176,
        230
      ],
      [
        -136,
        178
      ],
      [
        -14,
        183
      ],
      [
        137,
        121
      ],
      [
        70,
        399
      ],
      [
        111,
        -9
      ],
      [
        109,
        -176
      ],
      [
        85,
        23
      ],
      [
        -81,
        253
      ],
      [
        3,
        281
      ],
      [
        213,
        190
      ],
      [
        -182,
        214
      ],
      [
        -514,
        128
      ],
      [
        -229,
        -163
      ],
      [
        -193,
        -138
      ],
      [
        -272,
        -424
      ],
      [
        -304,
        -224
      ],
      [
        -209,
        -253
      ],
      [
        -46,
        -209
      ],
      [
        148,
        -142
      ],
      [
        30,
        -155
      ],
      [
        -123,
        -308
      ],
      [
        -16,
        -434
      ],
      [
        -64,
        -151
      ],
      [
        -107,
        -80
      ],
      [
        -466,
        -9
      ],
      [
        -325,
        -101
      ],
      [
        -750,
        -537
      ],
      [
        -423,
        -121
      ],
      [
        -214,
        7
      ],
      [
        -92,
        24
      ]
    ],
    [
      [
        18950,
        16107
      ],
      [
        -33,
        262
      ],
      [
        159,
        131
      ],
      [
        166,
        24
      ],
      [
        342,
        -127
      ],
      [
        210,
        49
      ],
      [
        -109,
        480
      ],
      [
        104,
        184
      ],
      [
        91,
        1
      ],
      [
        262,
        -193
      ],
      [
        43,
        171
      ],
      [
        242,
        70
      ],
      [
        60,
        -310
      ],
      [
        378,
        155
      ],
      [
        105,
        -164
      ],
      [
        -36,
        180
      ],
      [
        48,
        46
      ],
      [
        1007,
        278
      ],
      [
        9,
        95
      ],
      [
        249,
        -22
      ],
      [
        215,
        302
      ],
      [
        298,
        -71
      ]
    ],
    [
      [
        5789,
        19335
      ],
      [
        -252,
        391
      ],
      [
        -85,
        40
      ],
      [
        -370,
        -87
      ],
      [
        -171,
        -41
      ],
      [
        -327,
        17
      ],
      [
        -212,
        -79
      ]
    ],
    [
      [
        2857,
        18670
      ],
      [
        -309,
        196
      ],
      [
        -406,
        94
      ],
      [
        -93,
        307
      ],
      [
        -113,
        83
      ],
      [
        -94,
        271
      ],
      [
        -192,
        207
      ],
      [
        -148,
        411
      ],
      [
        -270,
        35
      ],
      [
        -176,
        96
      ],
      [
        -159,
        -20
      ],
      [
        -116,
        -108
      ],
      [
        -126,
        40
      ],
      [
        -57,
        342
      ],
      [
        -195,
        253
      ],
      [
        137,
        230
      ],
      [
        -60,
        586
      ],
      [
        -64,
        129
      ],
      [
        -45,
        89
      ],
      [
        265,
        331
      ],
      [
        46,
        149
      ],
      [
        -204,
        535
      ],
      [
        -273,
        270
      ],
      [
        -205,
        1392
      ],
      [
        4,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        5
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        5
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        5
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        5
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        5
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        5
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        5
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        5
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        5
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        5
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        5
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        5
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        5
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        5
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        5
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        5
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        5
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        5
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        5
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        5
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        5
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        5
      ],
      [
        2,
        0
      ],
      [
        8,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        1,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        5
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        2,
        0
      ],
      [
        3,
        0
      ],
      [
        0,
        1
      ],
      [
        0,
        3
      ],
      [
        5,
        0
      ],
      [
        0,
        1
      ],
      [
        0,
        3
      ],
      [
        6,
        1
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        1,
        0
      ],
      [
        4,
        0
      ],
      [
        0,
        3
      ],
      [
        0,
        1
      ],
      [
        5,
        0
      ],
      [
        0,
        2
      ],
      [
        0,
        2
      ],
      [
        3,
        0
      ],
      [
        2,
        0
      ],
      [
        0,
        2
      ],
      [
        0,
        3
      ],
      [
        4,
        0
      ],
      [
        7,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        -1
      ],
      [
        0,
        5
      ],
      [
        5,
        -1
      ],
      [
        0,
        5
      ],
      [
        5,
        -1
      ],
      [
        0,
        5
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        1,
        0
      ],
      [
        4,
        0
      ],
      [
        0,
        3
      ],
      [
        2,
        1
      ],
      [
        8,
        0
      ],
      [
        0,
        5
      ],
      [
        6,
        0
      ],
      [
        -1,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        -1
      ],
      [
        0,
        5
      ],
      [
        5,
        -1
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        6,
        -1
      ],
      [
        -1,
        5
      ],
      [
        6,
        -1
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        -1,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        6,
        -1
      ],
      [
        -1,
        5
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        -1
      ],
      [
        0,
        5
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        -1,
        5
      ],
      [
        11,
        -1
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        5
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        5
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        -1,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        -1,
        5
      ],
      [
        6,
        -1
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        1,
        0
      ],
      [
        4,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        9
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        5
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        9
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        9
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        17
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        5
      ],
      [
        31,
        0
      ],
      [
        0,
        -5
      ],
      [
        16,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        5
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        5
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        1
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        5
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        6,
        0
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        8
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        16,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        8
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        16,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        9
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        9
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        8
      ],
      [
        5,
        0
      ],
      [
        0,
        9
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        5
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        8
      ],
      [
        5,
        0
      ],
      [
        0,
        9
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        13
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        8
      ],
      [
        5,
        0
      ],
      [
        0,
        9
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        15,
        0
      ],
      [
        0,
        5
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        8
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        9
      ],
      [
        5,
        0
      ],
      [
        0,
        8
      ],
      [
        5,
        0
      ],
      [
        0,
        9
      ],
      [
        6,
        0
      ],
      [
        0,
        13
      ],
      [
        5,
        0
      ],
      [
        0,
        13
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        21,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        31,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        16,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        31,
        0
      ],
      [
        0,
        22
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        15,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        -5
      ],
      [
        2,
        0
      ],
      [
        3,
        0
      ],
      [
        0,
        5
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        9
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        5
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        5
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        5
      ],
      [
        16,
        0
      ],
      [
        0,
        4
      ],
      [
        15,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        5
      ],
      [
        16,
        0
      ],
      [
        0,
        4
      ],
      [
        15,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        5
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        5
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        5
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        15,
        0
      ],
      [
        0,
        5
      ],
      [
        16,
        0
      ],
      [
        0,
        4
      ],
      [
        16,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        5
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        16,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        5
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        21,
        0
      ],
      [
        0,
        5
      ],
      [
        15,
        0
      ],
      [
        0,
        4
      ],
      [
        16,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        5
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        16,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        8
      ],
      [
        -5,
        0
      ],
      [
        0,
        5
      ],
      [
        0,
        4
      ],
      [
        -5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        9
      ],
      [
        -5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        -5,
        0
      ],
      [
        0,
        9
      ],
      [
        -6,
        0
      ],
      [
        0,
        8
      ],
      [
        -5,
        0
      ],
      [
        0,
        9
      ],
      [
        -5,
        0
      ],
      [
        0,
        4
      ],
      [
        -5,
        0
      ],
      [
        0,
        5
      ],
      [
        -5,
        0
      ],
      [
        0,
        4
      ],
      [
        -6,
        0
      ],
      [
        0,
        8
      ],
      [
        -5,
        0
      ],
      [
        0,
        5
      ],
      [
        -5,
        0
      ],
      [
        0,
        8
      ],
      [
        -5,
        0
      ],
      [
        0,
        13
      ],
      [
        -5,
        0
      ],
      [
        0,
        9
      ],
      [
        -6,
        0
      ],
      [
        0,
        17
      ],
      [
        -5,
        0
      ],
      [
        0,
        34
      ],
      [
        -5,
        0
      ],
      [
        0,
        17
      ],
      [
        -5,
        0
      ],
      [
        0,
        9
      ],
      [
        -6,
        0
      ],
      [
        0,
        4
      ],
      [
        -5,
        0
      ],
      [
        0,
        22
      ],
      [
        -5,
        0
      ],
      [
        0,
        12
      ],
      [
        -5,
        0
      ],
      [
        0,
        5
      ],
      [
        -5,
        0
      ],
      [
        0,
        13
      ],
      [
        -6,
        0
      ],
      [
        0,
        8
      ],
      [
        -5,
        0
      ],
      [
        0,
        30
      ],
      [
        -5,
        0
      ],
      [
        0,
        13
      ],
      [
        -5,
        0
      ],
      [
        0,
        26
      ],
      [
        5,
        0
      ],
      [
        0,
        21
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        13
      ],
      [
        26,
        0
      ],
      [
        0,
        5
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        8
      ],
      [
        5,
        0
      ],
      [
        0,
        9
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        9
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        9
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        13
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        9
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        21,
        0
      ],
      [
        0,
        -4
      ],
      [
        16,
        0
      ],
      [
        0,
        -4
      ],
      [
        10,
        0
      ],
      [
        0,
        -4
      ],
      [
        5,
        0
      ],
      [
        0,
        -5
      ],
      [
        -5,
        0
      ],
      [
        0,
        -4
      ],
      [
        -10,
        0
      ],
      [
        0,
        4
      ],
      [
        -21,
        0
      ],
      [
        0,
        5
      ],
      [
        -10,
        0
      ],
      [
        0,
        -5
      ],
      [
        -6,
        0
      ],
      [
        0,
        -4
      ],
      [
        -5,
        0
      ],
      [
        0,
        -9
      ],
      [
        -5,
        0
      ],
      [
        0,
        -8
      ],
      [
        -5,
        0
      ],
      [
        0,
        -4
      ],
      [
        -6,
        0
      ],
      [
        0,
        -5
      ],
      [
        -5,
        0
      ],
      [
        0,
        -4
      ],
      [
        -5,
        0
      ],
      [
        0,
        -4
      ],
      [
        -5,
        0
      ],
      [
        0,
        -9
      ],
      [
        -5,
        0
      ],
      [
        0,
        -8
      ],
      [
        -6,
        0
      ],
      [
        0,
        -5
      ],
      [
        -5,
        0
      ],
      [
        0,
        -4
      ],
      [
        -5,
        0
      ],
      [
        0,
        -4
      ],
      [
        -5,
        0
      ],
      [
        0,
        -9
      ],
      [
        -5,
        0
      ],
      [
        0,
        -4
      ],
      [
        15,
        0
      ],
      [
        0,
        8
      ],
      [
        5,
        0
      ],
      [
        0,
        -12
      ],
      [
        -5,
        0
      ],
      [
        0,
        -9
      ],
      [
        -5,
        0
      ],
      [
        0,
        -9
      ],
      [
        -5,
        0
      ],
      [
        0,
        -8
      ],
      [
        5,
        0
      ],
      [
        0,
        -4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        9
      ],
      [
        5,
        0
      ],
      [
        0,
        8
      ],
      [
        5,
        0
      ],
      [
        0,
        9
      ],
      [
        5,
        0
      ],
      [
        0,
        8
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        6,
        0
      ],
      [
        0,
        8
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        -13
      ],
      [
        5,
        0
      ],
      [
        0,
        -4
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        36,
        0
      ],
      [
        0,
        -4
      ],
      [
        11,
        0
      ],
      [
        0,
        -4
      ],
      [
        5,
        0
      ],
      [
        0,
        -5
      ],
      [
        10,
        0
      ],
      [
        0,
        -4
      ],
      [
        5,
        0
      ],
      [
        0,
        -13
      ],
      [
        -5,
        0
      ],
      [
        0,
        -4
      ],
      [
        -5,
        0
      ],
      [
        0,
        4
      ],
      [
        -5,
        0
      ],
      [
        0,
        9
      ],
      [
        -5,
        0
      ],
      [
        0,
        4
      ],
      [
        -11,
        0
      ],
      [
        0,
        4
      ],
      [
        -36,
        0
      ],
      [
        0,
        -4
      ],
      [
        -16,
        0
      ],
      [
        0,
        -8
      ],
      [
        5,
        0
      ],
      [
        0,
        -13
      ],
      [
        -5,
        0
      ],
      [
        0,
        -9
      ],
      [
        -5,
        0
      ],
      [
        0,
        -4
      ],
      [
        -5,
        0
      ],
      [
        0,
        -4
      ],
      [
        -6,
        0
      ],
      [
        0,
        -5
      ],
      [
        -5,
        0
      ],
      [
        0,
        -4
      ],
      [
        -5,
        0
      ],
      [
        0,
        -4
      ],
      [
        -5,
        0
      ],
      [
        0,
        -5
      ],
      [
        -6,
        0
      ],
      [
        0,
        -4
      ],
      [
        -5,
        0
      ],
      [
        0,
        -4
      ],
      [
        -5,
        0
      ],
      [
        0,
        -4
      ],
      [
        -5,
        0
      ],
      [
        0,
        -5
      ],
      [
        -5,
        0
      ],
      [
        0,
        -4
      ],
      [
        -6,
        0
      ],
      [
        0,
        -4
      ],
      [
        -5,
        0
      ],
      [
        0,
        -17
      ],
      [
        -5,
        0
      ],
      [
        0,
        -5
      ],
      [
        -5,
        0
      ],
      [
        0,
        -8
      ],
      [
        5,
        0
      ],
      [
        0,
        -5
      ],
      [
        -5,
        0
      ],
      [
        0,
        -4
      ],
      [
        -11,
        0
      ],
      [
        0,
        -4
      ],
      [
        -5,
        0
      ],
      [
        0,
        -17
      ],
      [
        5,
        0
      ],
      [
        0,
        -9
      ],
      [
        6,
        0
      ],
      [
        0,
        -13
      ],
      [
        5,
        0
      ],
      [
        0,
        -4
      ],
      [
        5,
        0
      ],
      [
        0,
        -4
      ],
      [
        10,
        0
      ],
      [
        0,
        -5
      ],
      [
        6,
        0
      ],
      [
        0,
        -4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        9
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        8
      ],
      [
        5,
        0
      ],
      [
        0,
        13
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        16,
        0
      ],
      [
        0,
        -4
      ],
      [
        5,
        0
      ],
      [
        0,
        -4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        9
      ],
      [
        -5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        -4
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        9
      ],
      [
        5,
        0
      ],
      [
        0,
        8
      ],
      [
        5,
        0
      ],
      [
        0,
        9
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        -4
      ],
      [
        5,
        0
      ],
      [
        0,
        -4
      ],
      [
        -5,
        0
      ],
      [
        0,
        -9
      ],
      [
        -5,
        0
      ],
      [
        0,
        -4
      ],
      [
        -6,
        0
      ],
      [
        0,
        -9
      ],
      [
        -5,
        0
      ],
      [
        0,
        -17
      ],
      [
        21,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        21
      ],
      [
        16,
        0
      ],
      [
        0,
        -4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        -4
      ],
      [
        26,
        0
      ],
      [
        0,
        -13
      ],
      [
        10,
        0
      ],
      [
        0,
        -4
      ],
      [
        5,
        0
      ],
      [
        0,
        -9
      ],
      [
        -5,
        0
      ],
      [
        0,
        -4
      ],
      [
        -10,
        0
      ],
      [
        0,
        -22
      ],
      [
        -6,
        0
      ],
      [
        0,
        -4
      ],
      [
        -10,
        0
      ],
      [
        0,
        -4
      ],
      [
        -10,
        0
      ],
      [
        0,
        -4
      ],
      [
        -11,
        0
      ],
      [
        0,
        -5
      ],
      [
        -10,
        0
      ],
      [
        0,
        -4
      ],
      [
        -6,
        0
      ],
      [
        0,
        -4
      ],
      [
        -5,
        0
      ],
      [
        0,
        -5
      ],
      [
        -5,
        0
      ],
      [
        0,
        -8
      ],
      [
        -5,
        0
      ],
      [
        0,
        -4
      ],
      [
        -5,
        0
      ],
      [
        0,
        -5
      ],
      [
        -6,
        0
      ],
      [
        0,
        -4
      ],
      [
        -5,
        0
      ],
      [
        0,
        -4
      ],
      [
        -5,
        0
      ],
      [
        0,
        -9
      ],
      [
        -5,
        0
      ],
      [
        0,
        -8
      ],
      [
        -5,
        0
      ],
      [
        0,
        -5
      ],
      [
        -6,
        0
      ],
      [
        0,
        -4
      ],
      [
        -5,
        0
      ],
      [
        0,
        -4
      ],
      [
        -5,
        0
      ],
      [
        0,
        -5
      ],
      [
        -5,
        0
      ],
      [
        0,
        -4
      ],
      [
        -6,
        0
      ],
      [
        0,
        -13
      ],
      [
        6,
        0
      ],
      [
        0,
        -4
      ],
      [
        5,
        0
      ],
      [
        0,
        -4
      ],
      [
        5,
        0
      ],
      [
        0,
        -5
      ],
      [
        5,
        0
      ],
      [
        0,
        -4
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        18
      ],
      [
        5,
        0
      ],
      [
        0,
        8
      ],
      [
        -5,
        0
      ],
      [
        0,
        9
      ],
      [
        5,
        0
      ],
      [
        0,
        8
      ],
      [
        26,
        0
      ],
      [
        0,
        -4
      ],
      [
        5,
        0
      ],
      [
        0,
        -4
      ],
      [
        5,
        0
      ],
      [
        0,
        -9
      ],
      [
        -5,
        0
      ],
      [
        0,
        -21
      ],
      [
        -5,
        0
      ],
      [
        0,
        -9
      ],
      [
        5,
        0
      ],
      [
        0,
        -4
      ],
      [
        5,
        0
      ],
      [
        0,
        -34
      ],
      [
        -5,
        0
      ],
      [
        0,
        -10
      ],
      [
        0,
        -3
      ],
      [
        -8,
        0
      ],
      [
        -2,
        0
      ],
      [
        0,
        -5
      ],
      [
        -6,
        0
      ],
      [
        1,
        -34
      ],
      [
        -16,
        0
      ],
      [
        0,
        -4
      ],
      [
        -5,
        0
      ],
      [
        0,
        -13
      ],
      [
        -5,
        0
      ],
      [
        0,
        -4
      ],
      [
        5,
        0
      ],
      [
        0,
        -5
      ],
      [
        5,
        0
      ],
      [
        0,
        -4
      ],
      [
        26,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        -5,
        0
      ],
      [
        0,
        4
      ],
      [
        -16,
        0
      ],
      [
        0,
        4
      ],
      [
        -11,
        0
      ],
      [
        0,
        5
      ],
      [
        6,
        0
      ],
      [
        0,
        8
      ],
      [
        5,
        0
      ],
      [
        0,
        13
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        0,
        47
      ],
      [
        5,
        0
      ],
      [
        0,
        9
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        -4
      ],
      [
        11,
        0
      ],
      [
        0,
        -5
      ],
      [
        15,
        0
      ],
      [
        0,
        -4
      ],
      [
        11,
        0
      ],
      [
        0,
        -4
      ],
      [
        5,
        0
      ],
      [
        0,
        -13
      ],
      [
        5,
        0
      ],
      [
        0,
        -6
      ],
      [
        0,
        -3
      ],
      [
        6,
        0
      ],
      [
        0,
        -4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        9
      ],
      [
        -5,
        0
      ],
      [
        0,
        4
      ],
      [
        -5,
        0
      ],
      [
        0,
        9
      ],
      [
        -5,
        0
      ],
      [
        0,
        8
      ],
      [
        -6,
        0
      ],
      [
        0,
        5
      ],
      [
        -10,
        0
      ],
      [
        0,
        4
      ],
      [
        -11,
        0
      ],
      [
        0,
        8
      ],
      [
        -5,
        0
      ],
      [
        0,
        5
      ],
      [
        -5,
        0
      ],
      [
        0,
        13
      ],
      [
        5,
        0
      ],
      [
        0,
        12
      ],
      [
        16,
        0
      ],
      [
        0,
        -4
      ],
      [
        5,
        0
      ],
      [
        0,
        -4
      ],
      [
        11,
        0
      ],
      [
        0,
        -4
      ],
      [
        5,
        0
      ],
      [
        0,
        -9
      ],
      [
        5,
        0
      ],
      [
        0,
        -9
      ],
      [
        5,
        0
      ],
      [
        0,
        -4
      ],
      [
        5,
        0
      ],
      [
        0,
        -4
      ],
      [
        6,
        0
      ],
      [
        0,
        -4
      ],
      [
        5,
        0
      ],
      [
        0,
        -5
      ],
      [
        5,
        0
      ],
      [
        0,
        -4
      ],
      [
        5,
        0
      ],
      [
        0,
        -5
      ],
      [
        5,
        1
      ],
      [
        1,
        -9
      ],
      [
        5,
        0
      ],
      [
        0,
        -4
      ],
      [
        5,
        0
      ],
      [
        0,
        -4
      ],
      [
        5,
        0
      ],
      [
        0,
        -5
      ],
      [
        11,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        8
      ],
      [
        -5,
        0
      ],
      [
        0,
        9
      ],
      [
        -6,
        0
      ],
      [
        0,
        9
      ],
      [
        -1,
        -1
      ],
      [
        -4,
        0
      ],
      [
        0,
        17
      ],
      [
        -5,
        0
      ],
      [
        0,
        5
      ],
      [
        -5,
        0
      ],
      [
        0,
        13
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        -5,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        -4
      ],
      [
        5,
        0
      ],
      [
        0,
        -9
      ],
      [
        6,
        0
      ],
      [
        0,
        -4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        9
      ],
      [
        -5,
        0
      ],
      [
        0,
        13
      ],
      [
        15,
        0
      ],
      [
        0,
        -9
      ],
      [
        6,
        0
      ],
      [
        0,
        -4
      ],
      [
        5,
        0
      ],
      [
        0,
        -17
      ],
      [
        5,
        0
      ],
      [
        0,
        -5
      ],
      [
        5,
        0
      ],
      [
        0,
        2
      ],
      [
        0,
        3
      ],
      [
        11,
        0
      ],
      [
        0,
        1
      ],
      [
        0,
        3
      ],
      [
        10,
        1
      ],
      [
        0,
        3
      ],
      [
        6,
        0
      ],
      [
        -1,
        5
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        -5,
        0
      ],
      [
        0,
        9
      ],
      [
        -5,
        0
      ],
      [
        0,
        9
      ],
      [
        5,
        0
      ],
      [
        0,
        17
      ],
      [
        -36,
        0
      ],
      [
        0,
        4
      ],
      [
        -6,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        5
      ],
      [
        31,
        0
      ],
      [
        0,
        8
      ],
      [
        5,
        0
      ],
      [
        0,
        13
      ],
      [
        5,
        0
      ],
      [
        0,
        9
      ],
      [
        5,
        0
      ],
      [
        0,
        17
      ],
      [
        -5,
        0
      ],
      [
        0,
        8
      ],
      [
        -5,
        0
      ],
      [
        0,
        5
      ],
      [
        -5,
        0
      ],
      [
        0,
        4
      ],
      [
        -16,
        0
      ],
      [
        0,
        13
      ],
      [
        -5,
        0
      ],
      [
        0,
        4
      ],
      [
        -5,
        0
      ],
      [
        0,
        4
      ],
      [
        -5,
        0
      ],
      [
        0,
        17
      ],
      [
        -6,
        0
      ],
      [
        0,
        5
      ],
      [
        -10,
        0
      ],
      [
        0,
        -5
      ],
      [
        -11,
        0
      ],
      [
        0,
        5
      ],
      [
        -5,
        0
      ],
      [
        0,
        17
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        16,
        0
      ],
      [
        0,
        9
      ],
      [
        -5,
        0
      ],
      [
        0,
        17
      ],
      [
        -5,
        0
      ],
      [
        0,
        4
      ],
      [
        -11,
        0
      ],
      [
        0,
        4
      ],
      [
        -5,
        0
      ],
      [
        0,
        -4
      ],
      [
        -5,
        0
      ],
      [
        0,
        -4
      ],
      [
        -5,
        0
      ],
      [
        0,
        -4
      ],
      [
        -16,
        0
      ],
      [
        0,
        -5
      ],
      [
        -5,
        0
      ],
      [
        0,
        -13
      ],
      [
        -5,
        0
      ],
      [
        0,
        -21
      ],
      [
        5,
        0
      ],
      [
        0,
        -21
      ],
      [
        -5,
        0
      ],
      [
        0,
        -5
      ],
      [
        -6,
        0
      ],
      [
        0,
        5
      ],
      [
        -5,
        0
      ],
      [
        0,
        21
      ],
      [
        -5,
        0
      ],
      [
        0,
        30
      ],
      [
        5,
        0
      ],
      [
        0,
        13
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        20,
        0
      ],
      [
        0,
        9
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        5
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        16,
        0
      ],
      [
        0,
        4
      ],
      [
        20,
        0
      ],
      [
        0,
        5
      ],
      [
        11,
        0
      ],
      [
        0,
        8
      ],
      [
        5,
        0
      ],
      [
        0,
        9
      ],
      [
        -5,
        0
      ],
      [
        0,
        4
      ],
      [
        -5,
        0
      ],
      [
        0,
        4
      ],
      [
        -6,
        0
      ],
      [
        0,
        5
      ],
      [
        -20,
        0
      ],
      [
        0,
        4
      ],
      [
        -11,
        0
      ],
      [
        0,
        4
      ],
      [
        -5,
        0
      ],
      [
        0,
        5
      ],
      [
        -16,
        0
      ],
      [
        0,
        4
      ],
      [
        -26,
        0
      ],
      [
        0,
        4
      ],
      [
        -21,
        0
      ],
      [
        0,
        4
      ],
      [
        -31,
        0
      ],
      [
        0,
        5
      ],
      [
        -31,
        0
      ],
      [
        0,
        4
      ],
      [
        -21,
        0
      ],
      [
        0,
        4
      ],
      [
        -16,
        0
      ],
      [
        0,
        5
      ],
      [
        -21,
        0
      ],
      [
        0,
        4
      ],
      [
        -5,
        0
      ],
      [
        0,
        4
      ],
      [
        -5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        -5
      ],
      [
        21,
        0
      ],
      [
        0,
        -4
      ],
      [
        16,
        0
      ],
      [
        0,
        -4
      ],
      [
        21,
        0
      ],
      [
        0,
        -4
      ],
      [
        31,
        0
      ],
      [
        0,
        -5
      ],
      [
        31,
        0
      ],
      [
        0,
        -4
      ],
      [
        21,
        0
      ],
      [
        0,
        -4
      ],
      [
        31,
        0
      ],
      [
        0,
        -5
      ],
      [
        11,
        0
      ],
      [
        0,
        -4
      ],
      [
        10,
        0
      ],
      [
        0,
        -4
      ],
      [
        6,
        0
      ],
      [
        0,
        -4
      ],
      [
        20,
        0
      ],
      [
        0,
        -5
      ],
      [
        11,
        0
      ],
      [
        0,
        -4
      ],
      [
        5,
        0
      ],
      [
        0,
        -4
      ],
      [
        5,
        0
      ],
      [
        0,
        -5
      ],
      [
        5,
        0
      ],
      [
        0,
        -8
      ],
      [
        6,
        0
      ],
      [
        0,
        -13
      ],
      [
        5,
        0
      ],
      [
        0,
        -17
      ],
      [
        5,
        0
      ],
      [
        0,
        -13
      ],
      [
        -5,
        0
      ],
      [
        0,
        -9
      ],
      [
        5,
        0
      ],
      [
        0,
        -21
      ],
      [
        5,
        0
      ],
      [
        0,
        -17
      ],
      [
        6,
        0
      ],
      [
        0,
        -39
      ],
      [
        5,
        0
      ],
      [
        0,
        -17
      ],
      [
        -5,
        0
      ],
      [
        0,
        -13
      ],
      [
        -6,
        0
      ],
      [
        0,
        -25
      ],
      [
        -5,
        0
      ],
      [
        0,
        -18
      ],
      [
        5,
        0
      ],
      [
        0,
        -51
      ],
      [
        6,
        0
      ],
      [
        0,
        -7
      ],
      [
        0,
        -19
      ],
      [
        5,
        0
      ],
      [
        0,
        -4
      ],
      [
        5,
        0
      ],
      [
        0,
        -4
      ],
      [
        21,
        0
      ],
      [
        0,
        4
      ],
      [
        16,
        0
      ],
      [
        0,
        4
      ],
      [
        15,
        0
      ],
      [
        0,
        5
      ],
      [
        21,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        21,
        0
      ],
      [
        0,
        5
      ],
      [
        15,
        0
      ],
      [
        0,
        4
      ],
      [
        16,
        0
      ],
      [
        0,
        -4
      ],
      [
        52,
        0
      ],
      [
        0,
        4
      ],
      [
        31,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        9
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        5
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        5
      ],
      [
        63,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        6,
        0
      ],
      [
        0,
        9
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        15,
        0
      ],
      [
        0,
        5
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        9
      ],
      [
        16,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        9
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        9
      ],
      [
        6,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        5
      ],
      [
        15,
        0
      ],
      [
        0,
        4
      ],
      [
        16,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        5
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        16,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        5
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        16,
        0
      ],
      [
        0,
        -4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        5
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        5
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        5
      ],
      [
        21,
        0
      ],
      [
        0,
        4
      ],
      [
        16,
        0
      ],
      [
        0,
        4
      ],
      [
        47,
        0
      ],
      [
        0,
        5
      ],
      [
        5,
        0
      ],
      [
        0,
        -5
      ],
      [
        10,
        0
      ],
      [
        0,
        5
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        16,
        0
      ],
      [
        0,
        5
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        5
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        5
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        5
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        20,
        0
      ],
      [
        0,
        5
      ],
      [
        21,
        0
      ],
      [
        0,
        4
      ],
      [
        21,
        0
      ],
      [
        0,
        4
      ],
      [
        31,
        0
      ],
      [
        0,
        5
      ],
      [
        21,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        11,
        0
      ],
      [
        0,
        5
      ],
      [
        10,
        0
      ],
      [
        0,
        4
      ],
      [
        10,
        0
      ],
      [
        76,
        -94
      ],
      [
        37,
        -66
      ],
      [
        2,
        -30
      ],
      [
        2,
        -35
      ],
      [
        -4,
        -21
      ],
      [
        -8,
        -42
      ],
      [
        42,
        -52
      ],
      [
        21,
        -20
      ],
      [
        37,
        -34
      ],
      [
        24,
        -57
      ],
      [
        14,
        -36
      ],
      [
        3,
        -84
      ],
      [
        -56,
        -55
      ],
      [
        -38,
        -37
      ],
      [
        -48,
        -133
      ],
      [
        19,
        -155
      ],
      [
        5,
        -39
      ],
      [
        1,
        -10
      ],
      [
        5,
        -41
      ],
      [
        16,
        -128
      ]
    ],
    [
      [
        7582,
        28809
      ],
      [
        0,
        -4
      ],
      [
        21,
        0
      ],
      [
        0,
        4
      ],
      [
        5,
        0
      ],
      [
        0,
        4
      ],
      [
        8,
        0
      ],
      [
        36,
        -40
      ],
      [
        9,
        -68
      ],
      [
        -110,
        126
      ],
      [
        37,
        0
      ],
      [
        0,
        -22
      ],
      [
        -6,
        0
      ]
    ]
  ],
  "objects": {
    "main": {
      "type": "GeometryCollection",
      "geometries": [
        {
          "arcs": [
            [
              [
                0
              ]
            ],
            [
              [
                1,
                2,
                3,
                4
              ]
            ]
          ],
          "type": "MultiPolygon",
          "properties": {
            "ISO": "BEL",
            "NAME_0": "Belgium",
            "ID_1": 258,
            "NAME_1": "Antwerp",
            "VARNAME_1": "Amberes|Antuérpia|Antwerpen|Anvers|Anversa",
            "HASC_1": "BE.AN",
            "TYPE_1": "Provincie",
            "ENGTYPE_1": "Province"
          }
        },
        {
          "arcs": [
            [
              5
            ]
          ],
          "type": "Polygon",
          "properties": {
            "ISO": "BEL",
            "NAME_0": "Belgium",
            "ID_1": 259,
            "NAME_1": "Brussels",
            "VARNAME_1": "Bruselas|Brussel Hoofstadt|Brusselse Hoofdstedelijke Gewest|Brüssel|Bruxelas|Région de Bruxelles-Capitale",
            "HASC_1": "BE.BU",
            "TYPE_1": "Hoofdstedelijk Gewest|Région Capitale",
            "ENGTYPE_1": "Capital Region"
          }
        },
        {
          "arcs": [
            [
              6,
              7,
              8,
              9,
              -4
            ]
          ],
          "type": "Polygon",
          "properties": {
            "ISO": "BEL",
            "NAME_0": "Belgium",
            "ID_1": 260,
            "NAME_1": "East Flanders",
            "VARNAME_1": "Fiandra Orientale|Flandes Oriental|Flandre orientale|Flandres Oriental|Oost-Vlaanderen|Ost Flandern",
            "HASC_1": "BE.OV",
            "TYPE_1": "Provincie",
            "ENGTYPE_1": "Province"
          }
        },
        {
          "arcs": [
            [
              10,
              11,
              12,
              -7,
              -3,
              13
            ],
            [
              -6
            ]
          ],
          "type": "Polygon",
          "properties": {
            "ISO": "BEL",
            "NAME_0": "Belgium",
            "ID_1": 261,
            "NAME_1": "Flemish Brabant",
            "VARNAME_1": "Brabante Flamenco|Brabante Flamengo|Brabant Flamand|Vlaams Brabant",
            "HASC_1": "BE.VB",
            "TYPE_1": "Provincie",
            "ENGTYPE_1": "Province"
          }
        },
        {
          "arcs": [
            [
              [
                -13,
                14,
                15,
                16,
                17,
                -8
              ]
            ],
            [
              [
                18,
                19
              ]
            ]
          ],
          "type": "MultiPolygon",
          "properties": {
            "ISO": "BEL",
            "NAME_0": "Belgium",
            "ID_1": 262,
            "NAME_1": "Hainaut",
            "VARNAME_1": "Henegouwen|Hennegau",
            "HASC_1": "BE.HT",
            "TYPE_1": "Provincie",
            "ENGTYPE_1": "Province"
          }
        },
        {
          "arcs": [
            [
              20,
              21,
              22,
              23,
              -11,
              24,
              25,
              26
            ]
          ],
          "type": "Polygon",
          "properties": {
            "ISO": "BEL",
            "NAME_0": "Belgium",
            "ID_1": 263,
            "NAME_1": "Liege",
            "VARNAME_1": "Liège|Liegi|Lieja|Luik|Lüttich",
            "HASC_1": "BE.LG",
            "TYPE_1": "Provincie",
            "ENGTYPE_1": "Province"
          }
        },
        {
          "arcs": [
            [
              [
                -27,
                27
              ]
            ],
            [
              [
                -25,
                -14,
                -2,
                28
              ]
            ]
          ],
          "type": "MultiPolygon",
          "properties": {
            "ISO": "BEL",
            "NAME_0": "Belgium",
            "ID_1": 264,
            "NAME_1": "Limburg",
            "VARNAME_1": "Limbourg|Limburgo",
            "HASC_1": "BE.LI",
            "TYPE_1": "Provincie",
            "ENGTYPE_1": "Province"
          }
        },
        {
          "arcs": [
            [
              29,
              30,
              -22
            ]
          ],
          "type": "Polygon",
          "properties": {
            "ISO": "BEL",
            "NAME_0": "Belgium",
            "ID_1": 265,
            "NAME_1": "Luxembourg",
            "VARNAME_1": "Lussemburgo|Luxemburg|Luxemburgo",
            "HASC_1": "BE.LX",
            "TYPE_1": "Provincie",
            "ENGTYPE_1": "Province"
          }
        },
        {
          "arcs": [
            [
              -23,
              -31,
              31,
              -16,
              32
            ]
          ],
          "type": "Polygon",
          "properties": {
            "ISO": "BEL",
            "NAME_0": "Belgium",
            "ID_1": 266,
            "NAME_1": "Namur",
            "VARNAME_1": "Namen",
            "HASC_1": "BE.NA",
            "TYPE_1": "Provincie",
            "ENGTYPE_1": "Province"
          }
        },
        {
          "arcs": [
            [
              -24,
              -33,
              -15,
              -12
            ]
          ],
          "type": "Polygon",
          "properties": {
            "ISO": "BEL",
            "NAME_0": "Belgium",
            "ID_1": 267,
            "NAME_1": "Walloon Brabant",
            "VARNAME_1": "Brabante Valão|Brabant Wallon|Waals Brabant",
            "HASC_1": "BE.BW",
            "TYPE_1": "Provincie",
            "ENGTYPE_1": "Province"
          }
        },
        {
          "arcs": [
            [
              [
                -9,
                -18,
                33,
                -19,
                34
              ]
            ],
            [
              [
                35
              ]
            ]
          ],
          "type": "MultiPolygon",
          "properties": {
            "ISO": "BEL",
            "NAME_0": "Belgium",
            "ID_1": 268,
            "NAME_1": "West Flanders",
            "VARNAME_1": "Fiandra Occidentale|Flandes Occidental|Flandre occidentale|Flandres Ocidental|West Flandern|West-Vlaanderen",
            "HASC_1": "BE.WV",
            "TYPE_1": "Provincie",
            "ENGTYPE_1": "Province"
          }
        }
      ]
    }
  }
}
